/* ARTMiE Marketing Hub — game widget boot (served as assets/amh-game.js, cached across pages).
 * Reads window.__AMHGAME, set inline just before this script by snippets/amh-game.liquid. */
(function(){
  var RAW = window.__AMHGAME || {};
  // Newsletter landing (?amh.play=<gameId>) boots even when no popup is active — the exact
  // game is forced (or fetched from the Hub) and auto-opened for the invited visitor.
  var LAND = null; try { LAND = (new URLSearchParams(location.search)).get('amh.play'); } catch(e){}
  if (!RAW || (!RAW.active && !LAND)) return;
  // PERF: do ZERO work during page load. All widget work (config resolve, CSS inject, DOM build,
  // listeners) is deferred to the first idle moment AFTER the page has fully loaded, so the game
  // never competes with the storefront for the main thread on the critical path. The launcher
  // simply appears a beat after the page is interactive — invisible to Core Web Vitals.
  function boot(){
    var host = location.hostname.replace(/^www\./,'');
    // AMH_SUBFOLDER_MARKET 2026-10-06: a market on a subfolder of another domain (/en-ie/… on the SK store) plays,
    // localizes and claims as its own public host (IE → artmie.com), like every other market's domain
    var _sub = location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$)/);
    var SUBFOLDER_HOST = { 'en-ie': 'artmie.com', 'nl-nl': 'artmie.nl' };
    if (_sub && SUBFOLDER_HOST[_sub[1]]) host = SUBFOLDER_HOST[_sub[1]];
    // Attribution from the newsletter link (recipient id + newsletter campaign), kept for the
    // whole browser session so play/win/apply still attribute after in-store navigation.
    var NL = { nid: null, nlc: null };
    try {
      var qs = new URLSearchParams(location.search);
      NL.nid = qs.get('amh.nid') || null; NL.nlc = qs.get('amh.nlc') || null;
      if (NL.nid || NL.nlc) sessionStorage.setItem('amh_nl', JSON.stringify(NL));
      else { var pn = JSON.parse(sessionStorage.getItem('amh_nl') || 'null'); if (pn) NL = pn; }
    } catch(e){}
    function matchesLand(cfg){
      if (!LAND || !cfg) return false;
      if (cfg.id === LAND || cfg.campaignId === LAND) return true;
      var vs = (cfg.experiment && cfg.experiment.variants) || [];
      for (var i=0;i<vs.length;i++){ if (vs[i].campaignId === LAND) return true; }
      return false;
    }
    // Landing for a game that is NOT the live popup → fetch its resolved config from the Hub;
    // if that fails, fall back to whatever game IS live so the invited visitor still gets one.
    if (LAND && !matchesLand(RAW)){
      var api = String(RAW.apiBase || '').replace(/\/$/,'');
      if (api){
        fetch(api + '/api/public/games/' + encodeURIComponent(LAND) + '/config?host=' + encodeURIComponent(host))
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(j){ var c = j && j.config; if (c && c.active){ if (!c.apiBase) c.apiBase = api; bootMain(c, host, NL); } else if (RAW.active) bootMain(RAW, host, NL); })
          .catch(function(){ if (RAW.active) bootMain(RAW, host, NL); });
        return;
      }
    }
    if (RAW.active) bootMain(RAW, host, NL);
  }
  function bootMain(RAW, host, NL){
  var INVITED = !!LAND;
  if (!INVITED && Array.isArray(RAW.hosts) && RAW.hosts.length && RAW.hosts.indexOf(host) === -1) return;
  function clone(o){ try { return JSON.parse(JSON.stringify(o)); } catch(e){ return o; } }
  var EK = 'amh_exp_' + ((RAW.experiment && RAW.experiment.id) || RAW.id || 'x');

  // Resolve a full game config for a given experiment-variant key (null = weighted pick), then
  // localize per host. Cloning the raw config each time lets us render a DIFFERENT variant on
  // exit-intent (the "second game") without disturbing the sticky A/B assignment logic.
  function resolveVariant(vkey){
    var c = clone(RAW);
    if (c.experiment && c.experiment.variants && c.experiment.variants.length){
      var VARS = c.experiment.variants, chosen = null, vi;
      if (vkey){ for (vi=0;vi<VARS.length;vi++){ if (VARS[vi].key === vkey){ chosen = VARS[vi]; break; } } }
      if (!chosen){
        var tw = 0; for (vi=0;vi<VARS.length;vi++) tw += (VARS[vi].weight||1);
        var rr = Math.random()*tw, ac = 0; chosen = VARS[0];
        for (vi=0;vi<VARS.length;vi++){ ac += (VARS[vi].weight||1); if (rr <= ac){ chosen = VARS[vi]; break; } }
      }
      var vc = chosen.config || {};
      for (var vk in vc){ if (Object.prototype.hasOwnProperty.call(vc, vk)) c[vk] = vc[vk]; }
      c.__variant = chosen.key; c.experimentId = c.experiment.id || c.id; c.campaignId = chosen.campaignId || null;
    }
    if (c.i18n && c.i18n[host]){ var L = c.i18n[host]; for (var lk in L){ if (Object.prototype.hasOwnProperty.call(L, lk)) c[lk] = L[lk]; } }
    return c;
  }
  // A different variant than the current one — the exit-intent "second game".
  function altVariantKey(cur){
    var vs = (RAW.experiment && RAW.experiment.variants) || [];
    if (vs.length < 2) return null;
    var others = []; for (var i=0;i<vs.length;i++){ if (vs[i].key !== cur) others.push(vs[i].key); }
    return others.length ? others[Math.floor(Math.random()*others.length)] : null;
  }

  // New browser session? (drives cross-session game rotation just below.)
  var NEWSESS = false; try { if (!sessionStorage.getItem('amh_sess')){ NEWSESS = true; sessionStorage.setItem('amh_sess','1'); } } catch(e){}
  var stickyKey = null; try { stickyKey = localStorage.getItem(EK); } catch(e){}
  // If last session the shopper OPENED a game but never played it, offer a DIFFERENT one now —
  // maybe that game wasn't for them. Only rotates when the stored "didn't play" variant is still
  // the one they're assigned, and only across a fresh session (not on every page view).
  if (NEWSESS){
    var onp = null; try { onp = localStorage.getItem('amh_onp'); } catch(e){}
    if (onp && stickyKey && onp === stickyKey){ var altk = altVariantKey(stickyKey); if (altk){ stickyKey = altk; try { localStorage.setItem(EK, altk); } catch(e){} } }
    try { localStorage.removeItem('amh_onp'); } catch(e){}
  }
  // TEST MODE: ?amhgame=<type> (e.g. ?amhgame=quiz) forces that game so it can be tested in
  // isolation — bypasses the sticky A/B pick, the once-played guard and the audience gate.
  var TESTGAME = null; try { TESTGAME = (new URLSearchParams(location.search)).get('amhgame'); } catch(e){}
  if (TESTGAME && RAW.experiment && RAW.experiment.variants){
    for (var tvi=0; tvi<RAW.experiment.variants.length; tvi++){ var tvv = RAW.experiment.variants[tvi]; if (tvv.config && String(tvv.config.type) === TESTGAME){ stickyKey = tvv.key; break; } }
  }
  // Newsletter landing: if the linked game is one of the LIVE experiment variants, force it
  // (bypasses the weighted pick — the email promised exactly this game).
  if (LAND && RAW.experiment && RAW.experiment.variants){
    for (var lvi=0; lvi<RAW.experiment.variants.length; lvi++){ var lvv = RAW.experiment.variants[lvi]; if (lvv.campaignId === LAND){ stickyKey = lvv.key; break; } }
  }
  var C = resolveVariant(stickyKey);
  // Landing safety: a game opened on a host its i18n does NOT cover would render the raw
  // top-level config (unlocalized, un-stock-gated definitions). Never do that for invited
  // visitors — a landing link for an uncovered market simply does nothing.
  if (INVITED && C.i18n && !C.i18n[host]) return;
  if (C.__variant && !TESTGAME){ try { localStorage.setItem(EK, C.__variant); } catch(e){} }
  var playedThisSession = false, openedThisSession = false;
  function markOpened(){ openedThisSession = true; }
  // Remember an "opened but never played" so next session can rotate to another game.
  function recordOpenNoPlay(){ try { if (openedThisSession && !playedThisSession && C.__variant){ localStorage.setItem('amh_onp', C.__variant); } } catch(e){} }
  var U = C.ui || {};  // localized fixed chrome (reveal, buttons, lose, swipe, email, hints)
  // Consistent look: strip decorative emoji from all copy — the widget uses the brand SVG icons
  // (IC.*, below), NOT emoji, to match the storefront. Applied once to title/subtitle/launcher/cta
  // and every chrome string, so no game screen shows a stray emoji.
  function deEmoji(s){ return String(s==null?'':s).replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE00}-\u{FE0F}\u{200D}\u{2049}\u{203C}\u{2122}]/gu,'').replace(/\s{2,}/g,' ').trim(); }
  ['title','subtitle','buttonLabel','cta'].forEach(function(k){ if (C[k] != null) C[k] = deEmoji(C[k]); });
  for (var uk in U){ if (Object.prototype.hasOwnProperty.call(U, uk) && typeof U[uk] === 'string') U[uk] = deEmoji(U[uk]); }
  // ARTMiE brand icons (line/filled SVG, currentColor) — NOT emoji, to match the storefront.
  function svg(inner, vb){ return '<svg class="amhg-ic" viewBox="'+(vb||'0 0 24 24')+'" fill="none" aria-hidden="true">'+inner+'</svg>'; }
  var IC = {
    bag: svg('<path d="M7 8V6C7 4.67 7.53 3.4 8.46 2.46 9.4 1.53 10.67 1 12 1s2.6.53 3.54 1.46C16.47 3.4 17 4.67 17 6v2h3c.27 0 .52.11.71.29.18.19.29.44.29.71v12c0 .27-.11.52-.29.71-.19.18-.44.29-.71.29H4c-.27 0-.52-.11-.71-.29A1 1 0 0 1 3 21V9c0-.27.11-.52.29-.71C3.48 8.11 3.73 8 4 8h3ZM9 8h6V6c0-.8-.32-1.56-.88-2.12A3 3 0 0 0 12 3c-.8 0-1.56.32-2.12.88A3 3 0 0 0 9 6v2Z" fill="currentColor"/>'),
    clock: svg('<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 7.5v5l3 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'),
    tag: svg('<path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.83 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="7.5" cy="7.5" r="1.4" fill="currentColor"/>'),
    gift: svg('<path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7Zm0 0h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'),
    check: svg('<path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>')
  };

  // ── anonymous analytics + lead capture back to the Hub (fire-and-forget) ──
  var SID = null; try { SID = localStorage.getItem('amh_sid'); } catch(e){}
  if (!SID){ SID = 's' + Math.random().toString(36).slice(2) + Date.now().toString(36); try { localStorage.setItem('amh_sid', SID); } catch(e){} }
  function trackUrl(){ return C.apiBase ? (C.apiBase.replace(/\/$/,'') + '/api/public/track') : null; }
  function payload(type, extra){
    var p = { type: type, campaignId: C.campaignId || C.id || null, experimentId: C.experimentId || null, variant: C.__variant || null, storeCode: C.storeCode || null, market: host, sid: SID };
    if (NL && NL.nid) p.nid = NL.nid;   // newsletter recipient identity (?amh.nid)
    if (NL && NL.nlc) p.nlc = NL.nlc;   // newsletter campaign (?amh.nlc)
    if (extra){ for (var k in extra){ if (Object.prototype.hasOwnProperty.call(extra,k)) p[k] = extra[k]; } }
    return p;
  }
  function track(type, extra){
    var u = trackUrl(); if (!u) return;
    try {
      var data = JSON.stringify(payload(type, extra));
      // Use text/plain: it's a CORS-safelisted content-type, so the cross-origin beacon
      // needs NO preflight. application/json is NOT safelisted → the browser must preflight,
      // which sendBeacon can't do, so those beacons were silently dropped (play/win/apply lost).
      var sent = false;
      if (navigator.sendBeacon){ sent = navigator.sendBeacon(u, new Blob([data], { type: 'text/plain' })); }
      if (!sent){ fetch(u, { method:'POST', body:data, headers:{'Content-Type':'text/plain'}, keepalive:true, mode:'cors' }).catch(function(){}); }
    } catch(e){}
  }
  function trackLead(email, code){
    var u = trackUrl(); if (!u) return Promise.resolve({ delivered:false });
    try {
      return fetch(u, { method:'POST', body:JSON.stringify(payload('lead', { email:email, code:code })), headers:{'Content-Type':'text/plain'}, mode:'cors' })
        .then(function(r){ return r.json(); }).catch(function(){ return { delivered:false }; });
    } catch(e){ return Promise.resolve({ delivered:false }); }
  }

  var KEY = 'amh_game_' + (C.id || 'x') + '_won';
  var saved = null; try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch(e){}
  // Allow another play only after the replay-LOCK passes (not the shorter urgency timer), so a
  // won free prize can't be re-won the next day. Older saves without a lock fall back to exp.
  if (saved && (saved.lock ? saved.lock < Date.now() : (saved.exp && saved.exp < Date.now()))) { localStorage.removeItem(KEY); saved = null; }
  if (TESTGAME) saved = null;                                          // test mode always plays fresh
  // Invited (newsletter) visitors always get in: a saved WIN is restored, a lost play may retry.
  if (!TESTGAME && !INVITED && saved && saved.played && !saved.code && !saved.multi) return;    // already played and didn't win → don't nag
  var color = C.color || '#EF56A9';

  var css = '\
  .amhg-fab{position:fixed;left:max(14px,env(safe-area-inset-left));bottom:max(16px,env(safe-area-inset-bottom));z-index:2147483000;display:inline-flex;align-items:center;gap:8px;border:none;cursor:pointer;\
    background:'+color+';color:#fff;font-family:Poppins,system-ui,sans-serif;font-weight:700;font-size:14px;padding:12px 18px;border-radius:100px;\
    box-shadow:0 8px 24px rgba(0,0,0,.22);animation:amhgpulse 2.2s infinite}\
  @keyframes amhgpulse{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}\
  .amhg-ov{position:fixed;inset:0;z-index:2147483001;background:rgba(20,10,20,.6);backdrop-filter:blur(3px);display:none;align-items:center;justify-content:center;padding:max(14px,env(safe-area-inset-top)) max(12px,env(safe-area-inset-right)) max(14px,env(safe-area-inset-bottom)) max(12px,env(safe-area-inset-left))}\
  .amhg-ov.open{display:flex}\
  .amhg-card{background:#fff;border-radius:20px;max-width:420px;width:100%;padding:26px 24px;text-align:center;position:relative;font-family:Poppins,system-ui,sans-serif;box-shadow:0 30px 80px rgba(0,0,0,.4);max-height:92vh;max-height:92dvh;overflow:auto;-webkit-overflow-scrolling:touch}\
  .amhg-x{position:absolute;top:12px;right:14px;border:none;background:none;font-size:22px;line-height:1;cursor:pointer;color:#999}\
  .amhg-title{font-size:21px;font-weight:800;margin:0 0 4px;color:#1b1b1b}\
  .amhg-sub{font-size:13.5px;color:#777;margin:0 0 18px}    .amhg-hook{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:7px;margin:-8px 0 16px}    .amhg-hook img{width:34px;height:34px;border-radius:8px;object-fit:cover;border:1px solid #eee;box-shadow:0 1px 3px rgba(0,0,0,.12)}    .amhg-hk-l{font-size:12px;color:#888;font-weight:600}    .amhg-hk-chip{background:#1b1b1b;color:#fff;font-weight:800;font-size:13px;padding:3px 10px;border-radius:100px}    .amhg-hk-free{background:#1e9e6a}    .amhg-hk-g{flex-basis:100%;text-align:center;font-size:11.5px;color:#1e9e6a;font-weight:600;margin-top:2px}\
  .amhg-btn{border:none;cursor:pointer;background:'+color+';color:#fff;font-weight:700;font-size:15px;padding:12px 22px;border-radius:100px;font-family:inherit}\
  .amhg-btn:disabled{opacity:.5;cursor:default}\
  .amhg-btn2{background:#f0f0f3;color:#333;margin-left:8px}\
  .amhg-wheelwrap{position:relative;width:260px;height:260px;margin:6px auto 18px}\
  .amhg-wheel{width:260px;height:260px;border-radius:50%;transition:transform 4.6s cubic-bezier(.17,.67,.28,1);box-shadow:0 0 0 8px '+color+',0 0 0 12px #fff,0 12px 30px rgba(0,0,0,.25)}\
  .amhg-ptr{position:absolute;top:-6px;left:50%;transform:translateX(-50%);width:0;height:0;border-left:13px solid transparent;border-right:13px solid transparent;border-top:22px solid '+color+';z-index:2;filter:drop-shadow(0 2px 2px rgba(0,0,0,.3))}\
  .amhg-hub{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:44px;height:44px;border-radius:50%;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.25);z-index:2}\
  .amhg-prize{margin:8px 0 16px;padding:14px;border-radius:14px;background:#faf0f6;border:1px dashed '+color+'}\
  .amhg-code{font-size:20px;font-weight:800;letter-spacing:.06em;color:'+color+';font-family:ui-monospace,monospace}\
  .amhg-cards{position:relative;height:clamp(220px,40vh,380px);margin:6px 0 10px;touch-action:none;user-select:none}\
  .amhg-swipe{position:absolute;inset:0;border-radius:20px;overflow:hidden;box-shadow:0 14px 36px rgba(0,0,0,.22);background:#f6f4f8;will-change:transform,filter;cursor:grab}\
  .amhg-swipe.bg{transform:scale(.93) translateY(14px);filter:blur(10px) brightness(.98);opacity:.92;pointer-events:none;box-shadow:0 6px 20px rgba(0,0,0,.14)}\
  .amhg-swipe img{width:100%;height:100%;object-fit:contain;background:#f6f4f8;pointer-events:none;display:block}\
  .amhg-swipe .info{position:absolute;left:0;right:0;bottom:0;padding:34px 15px 14px;background:linear-gradient(to top,rgba(0,0,0,.78),rgba(0,0,0,.14) 66%,rgba(0,0,0,0))}\
  .amhg-swipe .info .nm{font-weight:700;font-size:15px;line-height:1.25;color:#fff;text-shadow:0 1px 4px rgba(0,0,0,.55)}\
  .amhg-swipe .info .deal{margin-top:7px}\
  .amhg-swipe .info .deal span{display:inline-block;background:'+color+';color:#fff;font-size:13px;font-weight:800;padding:4px 13px;border-radius:100px;box-shadow:0 2px 8px rgba(0,0,0,.3)}\
  .amhg-tag{position:absolute;top:18px;padding:6px 14px;border:3px solid;border-radius:10px;font-weight:800;font-size:20px;opacity:0;pointer-events:none;background:rgba(255,255,255,.9)}\
  .amhg-tag.like{left:16px;color:#1e9e6a;border-color:#1e9e6a;transform:rotate(-12deg)}\
  .amhg-tag.nope{right:16px;color:#e23b3b;border-color:#e23b3b;transform:rotate(12deg)}\
  .amhg-swhint{text-align:center;font-size:12px;color:#8a8a8a;margin:0 0 9px}\
  .amhg-swrow{display:flex;gap:30px;justify-content:center;align-items:flex-start;margin-top:2px}\
  .amhg-swbtn{display:flex;flex-direction:column;align-items:center;gap:5px;background:none;border:none;cursor:pointer;font-size:11.5px;color:#666;font-weight:600}\
  .amhg-round{width:62px;height:62px;border-radius:50%;border:1px solid #eee;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 16px rgba(0,0,0,.14);background:#fff;transition:transform .12s}\
  .amhg-swbtn:hover .amhg-round{transform:scale(1.08)}\
  .amhg-round svg{width:27px;height:27px}\
  .amhg-round.nope{color:#e23b3b}\
  .amhg-round.yes{background:'+color+';border-color:transparent;color:#fff}\
  .amhg-prog{font-size:12px;color:#999;margin:6px 0 0}\
  .amhg-summary .row{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 12px;border:1px dashed '+color+';border-radius:12px;margin:8px 0;text-align:left}\
  .amhg-q{font-weight:700;font-size:16px;margin:6px 0 14px}\
  .amhg-opt{display:block;width:100%;text-align:left;padding:12px 14px;margin:8px 0;border:1.5px solid #e6e6ea;border-radius:12px;background:#fff;cursor:pointer;font-size:14px;font-family:inherit;transition:border-color .12s,background .12s}\
  .amhg-opt:hover{border-color:'+color+'}\
  .amhg-opt:disabled{cursor:default;opacity:1}\
  .amhg-opt.ok{border-color:#1e9e6a;background:#eafaf1;color:#137a4f;font-weight:700}\
  .amhg-opt.bad{border-color:#e23b3b;background:#fdecec;color:#c0392b}\
  .amhg-qimg{width:100%;max-height:150px;object-fit:contain;border-radius:12px;background:#f6f4f8;margin:2px 0 12px}\
  .amhg-qfb{text-align:left;border-radius:12px;padding:11px 13px;margin:10px 0 2px}\
  .amhg-qfb.ok{background:#eafaf1;border:1px solid #bfe8d2}\
  .amhg-qfb.bad{background:#fdecec;border:1px solid #f6cccc}\
  .amhg-qfb b{display:block;font-size:14px;margin-bottom:3px}\
  .amhg-qfb.ok b{color:#137a4f}\
  .amhg-qfb.bad b{color:#c0392b}\
  .amhg-qfb span{display:block;font-size:12.5px;color:#555;line-height:1.4}\
  .amhg-qnext{margin-top:10px;width:100%}\
  .amhg-vouchers{display:flex;flex-direction:column;gap:9px;margin:6px 0 4px;text-align:left}\
  .amhg-vcard{display:flex;align-items:center;flex-wrap:wrap;gap:9px 11px;border:1px solid #eee;border-radius:14px;padding:9px 10px}\
  .amhg-vcard.free{border-color:#bfe8d2;background:#f4fbf7}\
  .amhg-vcard img{width:58px;height:58px;object-fit:cover;border-radius:10px;background:#f2f2f4;flex:none}\
  .amhg-vinfo{flex:1 1 120px;min-width:0}\
  .amhg-vname{font-size:13px;font-weight:700;line-height:1.25;margin-bottom:3px}\
  .amhg-vbadge{display:inline-block;font-size:11px;font-weight:800;letter-spacing:.02em;padding:2px 9px;border-radius:100px;color:#fff;background:'+color+'}\
  .amhg-vbadge.free{background:#1e9e6a}\
  .amhg-vcode{font-family:ui-monospace,monospace;font-size:11.5px;color:#999;margin-top:3px;cursor:pointer}\
  .amhg-vadd{flex:1 1 100%;justify-content:center;margin-top:4px;border:none;cursor:pointer;background:'+color+';color:#fff;font-weight:700;font-size:12.5px;padding:10px 12px;border-radius:100px;font-family:inherit;display:inline-flex;align-items:center;gap:6px}\
  .amhg-vadd .amhg-ic{width:14px;height:14px}\
  .amhg-vmin{font-size:10.5px;color:#8a8a8a;margin-top:2px}\
  .amhg-scratch{position:relative;width:100%;max-width:300px;height:172px;margin:10px auto 8px;border-radius:16px;overflow:hidden;box-shadow:0 8px 22px rgba(0,0,0,.16)}\
  .amhg-scratch .prize{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;background:#faf0f6;text-align:center;padding:10px}\
  .amhg-scratch canvas{position:absolute;inset:0;touch-action:none;cursor:grab}\
  .amhg-hint{font-size:12px;color:#999;margin:0 0 14px}\
  .amhg-timer{margin:12px auto 2px;font-size:13.5px;color:#333;background:#fff4fa;border:1px solid #f6cfe6;border-radius:100px;padding:7px 14px;display:inline-block}\
  .amhg-timer b{color:'+color+'}\
  .amhg-exp{color:#c0392b;font-weight:700}\
  .amhg-copyhint{font-size:11px;color:#aaa;margin-top:5px}\
  .amhg-code[data-copy]{cursor:pointer}\
  .amhg-grid{display:grid;gap:8px;margin:10px auto 14px;max-width:300px}\
  .amhg-mcard{position:relative;aspect-ratio:1;border:none;border-radius:12px;background:'+color+';cursor:pointer;font-size:26px;display:flex;align-items:center;justify-content:center;overflow:hidden;transition:background .15s}\
  .amhg-mcard .face{opacity:0;transition:opacity .15s}\
  .amhg-mcard.flip .face,.amhg-mcard.done .face{opacity:1}\
  .amhg-mcard.flip{background:#faf0f6}\
  .amhg-mcard.done{background:#eafaf1;cursor:default}\
  .amhg-mback{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:800;font-size:24px;opacity:.9;transition:opacity .12s}\
  .amhg-mcard.flip .amhg-mback,.amhg-mcard.done .amhg-mback{opacity:0}\
  .amhg-mcard--img img.face{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}\
  .amhg-mcard--img.done{box-shadow:inset 0 0 0 3px #1e9e6a}\
  .amhg-input{width:100%;box-sizing:border-box;padding:12px 14px;border:1.5px solid #e6e6ea;border-radius:12px;font-size:15px;font-family:inherit;outline:none;text-align:center}\
  .amhg-input:focus{border-color:'+color+'}\
  .amhg-err{color:#c0392b;font-size:12px;margin:6px 0 0}\
  .amhg-sent{margin:0 0 12px;font-size:13px;font-weight:600;color:#1e9e6a;background:#eafaf1;border-radius:100px;padding:8px 12px;display:inline-block}\
  .amhg-won{display:flex;align-items:center;gap:12px;text-decoration:none;color:#1b1b1b;border:1px solid #eee;border-radius:14px;padding:10px;margin:2px 0 12px;text-align:left}\
  .amhg-won:hover{border-color:'+color+'}\
  .amhg-won img{width:64px;height:64px;object-fit:cover;border-radius:10px;background:#f2f2f4;flex:none}\
  .amhg-won span{font-size:14px;font-weight:700;line-height:1.3}\
  .amhg-minord{margin:8px auto 2px;font-size:12.5px;color:#555;background:#f5f5f7;border-radius:100px;padding:6px 12px;display:inline-block}\
  .amhg-minord b{color:#1b1b1b}\
  .amhg-ic{width:1.15em;height:1.15em;flex:none;vertical-align:-0.18em}\
  .amhg-rhead{display:flex;align-items:center;justify-content:center;gap:8px;font-size:19px;font-weight:800;color:#1b1b1b;margin:2px 6px 14px;line-height:1.25}\
  .amhg-rhead .amhg-ic{width:22px;height:22px;color:'+color+'}\
  .amhg-wonp{display:flex;align-items:center;gap:12px;text-decoration:none;color:#1b1b1b;border:1px solid #eee;border-radius:14px;padding:10px;margin:0 0 12px;text-align:left}\
  .amhg-wonp:hover{border-color:'+color+'}\
  .amhg-wonp img{width:66px;height:66px;object-fit:cover;border-radius:10px;background:#f2f2f4;flex:none}\
  .amhg-wonp__i{display:flex;flex-direction:column;gap:3px;min-width:0}\
  .amhg-wonp__n{font-size:14px;font-weight:700;line-height:1.3}\
  .amhg-wprice{font-size:13px;color:#888}\
  .amhg-wprice s{color:#aaa}\
  .amhg-wprice b{color:'+color+';font-weight:800;letter-spacing:.02em}\
  .amhg-cond{display:flex;align-items:center;gap:8px;justify-content:center;font-size:12.5px;color:#555;background:#f6f6f8;border-radius:12px;padding:9px 12px;margin:0 0 12px;text-align:left}\
  .amhg-cond .amhg-ic{width:16px;height:16px;color:#1e9e6a}\
  .amhg-btn--big{width:100%;font-size:15.5px;padding:13px;display:inline-flex;align-items:center;justify-content:center;gap:9px}\
  .amhg-btn--big .amhg-ic{width:19px;height:19px}\
  .amhg-rfoot{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:12px;flex-wrap:wrap}\
  .amhg-codechip{display:inline-flex;align-items:center;gap:7px;cursor:pointer;background:#faf0f6;border:1px dashed '+color+';border-radius:100px;padding:7px 14px;font-family:ui-monospace,monospace;font-size:14px;color:'+color+'}\
  .amhg-codechip .amhg-ic{width:15px;height:15px}\
  .amhg-codechip.ok{border-style:solid;background:#eafaf1;color:#1e9e6a}\
  .amhg-timer2{display:inline-flex;align-items:center;gap:6px;font-size:13px;color:#c0392b;font-weight:600}\
  .amhg-timer2 .amhg-ic{width:15px;height:15px}\
  .amhg-btnrow{display:flex;gap:8px;justify-content:center;margin-top:8px;flex-wrap:wrap}\
  .amhg-plabel{font-size:11px;color:#888;margin-bottom:4px}\
  .amhg-recs{display:flex;flex-direction:column;gap:8px;margin:10px 0 2px;text-align:left}\
  .amhg-rec{display:flex;align-items:center;gap:10px;padding:8px;border:1px solid #eee;border-radius:12px;text-decoration:none;color:#222}\
  .amhg-rec:hover{border-color:'+color+'}\
  .amhg-rec img{width:44px;height:44px;object-fit:cover;border-radius:8px;background:#f2f2f4}\
  .amhg-rec span{font-size:13px;font-weight:600}\
  .amhg-eb{background:'+color+';color:#fff;font-size:13.5px;font-weight:650;line-height:1.4;display:flex;align-items:center;justify-content:center;gap:9px;padding:12px 42px 12px 16px;border-radius:14px;margin:0 0 14px}\
  .amhg-eb .amhg-ic{width:20px;height:20px;flex:none}\
  .amhg-vname,.amhg-wonp__n{overflow-wrap:anywhere}\
  @media (max-width:480px){\
    .amhg-card{padding:22px 15px calc(18px + env(safe-area-inset-bottom))}\
    .amhg-title{font-size:19px}\
    .amhg-rhead{font-size:17px;margin-bottom:12px}\
    .amhg-sub{font-size:13px;margin-bottom:14px}\
    .amhg-vcard img{width:52px;height:52px}\
    .amhg-btn2{margin-left:0}\
    .amhg-cards{height:clamp(200px,44dvh,360px)}\
  }\
  ';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // Audience targeting: optionally show only to first-time or returning visitors.
  // A "visit" = a browser session; the running total is kept in localStorage.
  var visits = 1;
  try {
    visits = parseInt(localStorage.getItem('amh_visits') || '0', 10) || 0;
    if (!sessionStorage.getItem('amh_visit_counted')) { visits++; localStorage.setItem('amh_visits', String(visits)); sessionStorage.setItem('amh_visit_counted', '1'); }
  } catch(e){ visits = 1; }
  var AUD = C.audience || 'all';
  if (!TESTGAME && !INVITED && AUD === 'new' && visits > 1) return;         // only first-time visitors
  if (!TESTGAME && !INVITED && AUD === 'returning' && visits < 2) return;   // only visitors here 2+ times

  var ov = document.createElement('div'); ov.className = 'amhg-ov';
  ov.innerHTML = '<div class="amhg-card"><button class="amhg-x" aria-label="Close">&times;</button><div class="amhg-eb" style="display:none"></div><div class="amhg-body"></div></div>';
  document.body.appendChild(ov);
  var body = ov.querySelector('.amhg-body');
  var eb = ov.querySelector('.amhg-eb');
  function showExitBanner(msg){ if (eb){ eb.innerHTML = IC.gift + '<span>' + esc(deEmoji(msg)) + '</span>'; eb.style.display = ''; } }
  function hideExitBanner(){ if (eb){ eb.style.display = 'none'; } }
  var fab = document.createElement('button'); fab.className = 'amhg-fab';
  fab.innerHTML = (saved && (saved.code || saved.multi)) ? (IC.tag+'<span>'+esc(U.savedDeal || 'Your deal')+'</span>') : (IC.gift+'<span>'+esc(C.buttonLabel || 'Win a discount')+'</span>');
  // Default bottom-LEFT so we never cover a bottom-right live-chat bubble. Operator can force 'right'.
  if (C.position === 'right') { fab.style.left = 'auto'; fab.style.right = '18px'; }
  document.body.appendChild(fab);
  // count the launcher being seen once per visitor per day (funnel top)
  try { var IK = 'amh_imp_' + (C.id||'x') + '_' + todayKey(); if (!localStorage.getItem(IK)){ localStorage.setItem(IK, '1'); track('impression'); } } catch(e){ track('impression'); }

  // ── Keep the launcher CLEAR of the cookie-consent banner (or any bottom-anchored fixed bar):
  //    lift it above the bar while shown, drop back when gone. Designed to NOT flash and NOT cost
  //    performance: geometry is captured ONCE (never resets the live style), writes are IDEMPOTENT
  //    (only when the target actually changes), there is NO scroll handler (fixed bars don't move on
  //    scroll), and it watches the few consent elements directly instead of the whole page. ──
  (function(){
    var GAP = 12;
    var SELS = '#artmie-cc, [id*="consent"], [class*="consent"], [id*="cookie"], [class*="cookie"], #shopify-pc__banner, [data-consent-banner]';
    // Capture the launcher's RESTING geometry once — it has no inline bottom yet, so this IS the base.
    // We measure obstacles against THIS stored rect, never against the live (possibly-lifted) rect,
    // so apply() never has to reset the style first → no flicker.
    var b0 = fab.getBoundingClientRect();
    var baseBottom = window.innerHeight - b0.bottom, fabH = b0.height, fabLeft = b0.left, fabRight = b0.right;
    var appliedLift = -1, timer = 0, observed = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

    function computeLift(){
      var vh = window.innerHeight, restTop = vh - baseBottom - fabH, lift = 0, seen = [], els;
      try { els = document.querySelectorAll(SELS); } catch(e){ return 0; }
      for (var i = 0; i < els.length; i++){
        var el = els[i];
        if (el === fab || el.contains(fab) || seen.indexOf(el) >= 0) continue; seen.push(el);
        var s = getComputedStyle(el);
        if (s.position !== 'fixed' && s.position !== 'sticky') continue;
        if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity || '1') === 0) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 20 || r.height < 20) continue;
        if (r.left >= fabRight || r.right <= fabLeft) continue;   // must overlap the launcher horizontally
        if (r.top >= vh || r.bottom <= restTop) continue;         // off-screen, or entirely above the resting launcher
        var need = (vh - r.top) + GAP;                            // lift to just above this bar's top edge
        if (need > lift) lift = need;
      }
      var maxLift = vh - fabH - 12; if (lift > maxLift) lift = maxLift; if (lift < 0) lift = 0;
      return Math.round(lift);
    }
    function apply(){
      timer = 0;
      if (!fab || fab.style.display === 'none') return;
      var lift = computeLift();
      if (lift === appliedLift) return;                          // unchanged → no write → NO FLASH
      appliedLift = lift;
      fab.style.bottom = lift > 0 ? (lift + 'px') : '';
    }
    function schedule(){ if (timer) return; timer = setTimeout(apply, 80); } // setTimeout (not rAF) → also runs in a background tab
    function watch(){
      var els; try { els = document.querySelectorAll(SELS); } catch(e){ return; }
      for (var i = 0; i < els.length; i++){
        var el = els[i];
        if (observed && !observed.has(el)){ observed.add(el);   // one cheap targeted observer per consent element
          try { new MutationObserver(schedule).observe(el, { attributes: true, attributeFilter: ['class','style'], childList: true }); } catch(e){}
        }
      }
    }
    watch(); schedule();
    addEventListener('resize', schedule, { passive: true });
    addEventListener('visibilitychange', schedule);
    // Cheap: watch only body's DIRECT children (add/remove) so a banner that appears OR is removed
    // is caught. NOT subtree, NOT attributes — so it costs nothing while the page scrolls/animates.
    try { new MutationObserver(function(){ watch(); schedule(); }).observe(document.body, { childList: true }); } catch(e){}
    // Short poll only to DISCOVER a late-injected banner + attach its observer, then stop (no ongoing cost).
    var t = 0, iv = setInterval(function(){ watch(); schedule(); if (++t > 24) clearInterval(iv); }, 500); // ~12s
  })();

  function close(){ ov.classList.remove('open'); recordOpenNoPlay(); }
  window.addEventListener('pagehide', recordOpenNoPlay);
  ov.querySelector('.amhg-x').addEventListener('click', close);
  ov.addEventListener('click', function(e){ if(e.target===ov) close(); });
  fab.addEventListener('click', function(){ if (ov.classList.contains('open')) return; markOpened(); hideExitBanner(); ov.classList.add('open'); if (saved && saved.multi) showMultiReveal(saved.vouchers || [], saved.note, true); else if (saved && saved.code) showReveal(saved); else render(); });
  if (TESTGAME){ markOpened(); ov.classList.add('open'); render(); }   // test mode: open the forced game now
  else if (INVITED){
    // Newsletter landing: open the game right away — restore a saved win, else play.
    markOpened(); ov.classList.add('open');
    if (saved && saved.multi) showMultiReveal(saved.vouchers || [], saved.note, true);
    else if (saved && saved.code) showReveal(saved);
    else render();
    track('nlopen');
  }

  // ── Cart nudge: a free-product prize is a buy-X-get-free — until the basket holds the
  //    "buy" side, Shopify shows the prize at full price and says nothing. Shoppers read that
  //    as "not free" and leave (reported 2026-09-23, MXH74801). On the cart page, say exactly
  //    where they stand: how much more to add, or that the prize is now free. ──
  (function(){
    if (!/^\/cart(\/|$)/.test(location.pathname)) return;
    if (!saved) return;
    var prizes = [];
    if (saved.product && saved.product.variantId) prizes.push({ name: (saved.product.name || saved.label || ''), variantId: String(saved.product.variantId), minOrder: saved.minOrder || '' });
    if (saved.multi) (saved.vouchers || []).forEach(function(v){ if (v.free && v.variantId) prizes.push({ name: v.name || '', variantId: String(v.variantId), minOrder: v.minOrder || '' }); });
    if (!prizes.length) return;
    var box = document.createElement('div'); box.className = 'amhg-cartnote';
    box.style.cssText = 'display:none;margin:0 auto 14px;max-width:1200px;padding:12px 16px;border-radius:14px;background:'+color+';color:#fff;font:600 14px/1.45 Poppins,sans-serif;box-sizing:border-box;';
    var mount = document.querySelector('main, #MainContent, .cart, form[action*="/cart"]') || document.body;
    mount.insertBefore(box, mount.firstChild);
    function money(n, cur){ try { return new Intl.NumberFormat(undefined, { style:'currency', currency:cur }).format(n); } catch(e){ return n.toFixed(2)+' '+cur; } }
    function refresh(){
      fetch('/cart.js', { credentials:'same-origin' }).then(function(r){ return r.json(); }).then(function(cart){
        var items = cart.items || [], cur = cart.currency || '', lines = [];
        prizes.forEach(function(p){
          var li = null; for (var i=0;i<items.length;i++){ if (String(items[i].variant_id) === p.variantId){ li = items[i]; break; } }
          if (!li) return; // prize not in the basket (removed) — nothing to say
          var others = 0; items.forEach(function(it){ if (String(it.variant_id) !== p.variantId) others += it.final_line_price; });
          if (li.final_line_price === 0){ lines.push('✓ ' + esc(p.name) + ' — ' + esc(U.free || 'FREE')); return; }
          var need = parseFloat(String(p.minOrder).replace(/[^0-9.,]/g,'').replace(',','.')) || 0;
          var left = Math.max(0, need - others/100);
          var cond = (U.freeCondition || 'Free when you add {x} of other products to your basket').replace('{x}', p.minOrder || '');
          lines.push(esc(p.name) + ': ' + esc(cond) + (left > 0 ? ' (+' + esc(money(left, cur)) + ')' : ''));
        });
        if (!lines.length){ box.style.display = 'none'; return; }
        box.innerHTML = lines.join('<br>'); box.style.display = '';
      }).catch(function(){});
    }
    refresh(); setInterval(refresh, 4000);
  })();

  // ── Exit-intent: when the shopper moves the cursor to leave (up toward the tab/close),
  //    offer a surprise — a SECOND game if they already played, else a "don't leave" reminder.
  //    Fires at most once per session, desktop pointer only, and never over an open game. ──
  (function(){
    var EI = C.exitIntent || {};
    if (EI.enabled === false) return;
    if (saved && (saved.code || saved.multi)) return;                  // already holding a prize — no nag
    if (!window.matchMedia || !window.matchMedia('(pointer:fine)').matches) return; // needs a mouse
    try { if (sessionStorage.getItem('amh_exit_done')) return; } catch(e){}
    var armed = false; setTimeout(function(){ armed = true; }, 3500);  // grace period after load
    function onLeave(e){
      if (!armed || (e.clientY != null && e.clientY > 0)) return;      // only when leaving via the top
      if (ov.classList.contains('open')) return;                       // already engaged
      try { if (sessionStorage.getItem('amh_exit_done')) return; sessionStorage.setItem('amh_exit_done','1'); } catch(_){}
      document.removeEventListener('mouseleave', onLeave);
      var hasPlayed = playedThisSession || (saved && saved.played);
      var msg;
      if (hasPlayed){
        var alt = altVariantKey(C.__variant);
        if (alt){ C = resolveVariant(alt); U = C.ui || {}; color = C.color || color; try { localStorage.setItem(EK, alt); } catch(__){} }
        msg = EI.msgPlayed || U.exitPlayed || "Wait — here's another game, don't leave yet!";
      } else {
        msg = EI.msgNotPlayed || U.exitNotPlayed || "Wait — you can still win something!";
      }
      showExitBanner(msg);
      markOpened();
      ov.classList.add('open');
      render();
    }
    document.addEventListener('mouseleave', onLeave);
  })();

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  // ── Reward-first hook: the game's CONCRETE prizes, shown before playing (the conversion hook). ──
  function hookData(){
    var t = C.type, maxPct = 0, freeN = 0, imgs = [];
    function pctOf(x){ var m = String(x==null?'':x).match(/(\d+)\s*%/); return m ? parseInt(m[1],10) : 0; }
    function addImg(u){ if (u && imgs.length < 3) imgs.push(u); }
    if (t === 'quiz'){ var vs = (C.quiz||{}).vouchers||[]; for (var i=0;i<vs.length;i++){ if (vs[i].free){ freeN++; addImg(vs[i].img); } else if ((vs[i].pct|0) > maxPct) maxPct = vs[i].pct|0; } }
    if (t === 'memory'){ var ps = (C.memory||{}).prizes||[]; freeN = ps.length; for (var a=0;a<ps.length;a++) addImg(ps[a].img); }
    if (t === 'scratch'){ var sp = (C.scratch||{}).prizes||[]; for (var b=0;b<sp.length;b++){ if (sp[b].product){ freeN++; addImg(sp[b].product.img); } else { var pc = pctOf(sp[b].label); if (pc > maxPct) maxPct = pc; } } }
    if (t === 'swipe'){ var pr = (C.swipe||{}).products||[]; for (var d=0;d<pr.length;d++){ var pc2 = pctOf(pr[d].deal); if (pc2 > maxPct) maxPct = pc2; addImg(pr[d].img); } }
    if (t === 'wheel'){ var sg = (C.wheel && C.wheel.segments)||[]; for (var e2=0;e2<sg.length;e2++){ var pc3 = pctOf(sg[e2].label); if (pc3 > maxPct) maxPct = pc3; if (sg[e2].product) freeN++; } }
    return { maxPct: maxPct, freeN: freeN, imgs: imgs, q: (C.quiz && C.quiz.perPlay) || 5 };
  }
  // Fill the {max}/{n}/{q} tokens in title/subtitle from the LIVE prizes — the promise stays truthful.
  function fill(str){ var h = hookData(); return String(str==null?'':str).replace(/\{max\}/g, String(h.maxPct||'')).replace(/\{n\}/g, String(h.freeN||'')).replace(/\{q\}/g, String(h.q||5)); }
  // The visual prize strip: real prize photos + value chips + a guarantee line where every play wins.
  function hookStrip(){
    var h = hookData(), bits = [];
    for (var i=0;i<h.imgs.length;i++) bits.push('<img src="'+esc(h.imgs[i])+'" alt="" loading="lazy">');
    if (h.freeN) bits.push('<span class="amhg-hk-chip amhg-hk-free">'+esc(U.hookFreeProduct||'FREE product')+(h.freeN>1?' ×'+h.freeN:'')+'</span>');
    if (h.maxPct) bits.push('<span class="amhg-hk-chip">−'+h.maxPct+'%</span>');
    if (!bits.length) return '';
    var g = (C.type==='wheel'||C.type==='quiz'||C.type==='scratch') ? '<span class="amhg-hk-g">'+esc(U.hookGuaranteed||'Every finish wins a reward')+'</span>' : '';
    return '<div class="amhg-hook"><span class="amhg-hk-l">'+esc(U.hookPrizes||'You can win:')+'</span>'+bits.join('')+g+'</div>';
  }

  function expiryTs(){
    var e = C.expiry || {};
    if (e.type === 'midnight'){ var d = new Date(); d.setHours(23,59,59,999); return d.getTime(); }
    if (e.hours) return Date.now() + e.hours*3600*1000;
    return 0; // no timer configured
  }
  function fmtLeft(ms){ if (ms<0) ms=0; var s=Math.floor(ms/1000), h=Math.floor(s/3600), m=Math.floor((s%3600)/60), ss=s%60; return (h>0?h+'h ':'')+(m<10?'0':'')+m+'m '+(ss<10?'0':'')+ss+'s'; }
  function fmtMoney(p, cur){ var n=parseFloat(p); if(isNaN(n)) return String(p||''); return n.toFixed(2).replace('.',',')+(cur?(' '+cur):''); }
  /** Reward reveal: tap-to-copy code, one-tap apply, live countdown, saved for later. */
  /** Reward reveal — a clean, scannable overview: what you won, its value, how to get it. */
  function showReveal(r, note){
    var T = U;
    var hasVariant = !!(r.product && r.product.variantId);
    var isProduct = !!r.product;
    var applyLabel = hasVariant ? (T.addToBasket || 'Add to basket') : (C.cta || 'Apply & shop');
    var priceHtml = (r.product && r.product.price) ? '<span class="amhg-wprice"><s>'+esc(fmtMoney(r.product.price, r.product.currency==='EUR'?'€':(r.product.currency||'')))+'</s> <b>'+esc(T.free || 'FREE')+'</b></span>' : '';
    var condHtml = r.minOrder ? '<div class="amhg-cond">'+IC.check+'<span>'+esc((T.freeCondition || 'Free when you add {x} of other products to your basket').replace('{x}', r.minOrder))+'</span></div>' : '';

    if (isProduct){
      body.innerHTML =
        '<div class="amhg-rhead">'+IC.gift+'<span>'+esc(r.label || T.youWon || 'You won!')+'</span></div>'+
        (note ? '<div class="amhg-sent">'+esc(note)+'</div>' : '')+
        '<a class="amhg-wonp" href="'+esc(r.product.url||'#')+'">'+(r.product.img?'<img src="'+esc(r.product.img)+'" alt="">':'')+'<span class="amhg-wonp__i"><span class="amhg-wonp__n">'+esc(r.product.name||'')+'</span>'+priceHtml+'</span></a>'+
        condHtml+
        '<button class="amhg-btn amhg-btn--big" data-apply>'+IC.bag+'<span>'+esc(applyLabel)+'</span></button>'+
        '<div class="amhg-rfoot"><span class="amhg-codechip" data-copy title="'+esc(T.tapToCopy||'tap to copy')+'">'+IC.tag+'<b>'+esc(r.code)+'</b></span>'+(r.exp?'<span class="amhg-timer2" data-timer></span>':'')+'</div>';
    } else {
      body.innerHTML =
        '<div class="amhg-rhead">'+IC.gift+'<span>'+esc(r.label || 'Your reward')+'</span></div>'+
        (note ? '<div class="amhg-sent">'+esc(note)+'</div>' : '')+
        '<div class="amhg-prize"><div class="amhg-plabel">'+esc(T.yourCode || 'Your code')+'</div><div class="amhg-code" data-copy>'+esc(r.code)+'</div><div class="amhg-copyhint">'+esc(T.tapToCopy || 'tap to copy')+'</div></div>'+
        (r.minOrder?'<div class="amhg-cond">'+IC.bag+'<span>'+esc((T.minOrder||'Minimum order')+': ')+'<b>'+esc(r.minOrder)+'</b></span></div>':'')+
        (r.exp?'<div class="amhg-timer" data-timer></div>':'')+
        '<div class="amhg-btnrow"><button class="amhg-btn" data-apply>'+esc(applyLabel)+'</button><button class="amhg-btn amhg-btn2" data-copy2>'+esc(T.copyBtn || 'Copy code')+'</button></div>';
    }
    function copy(){ try { navigator.clipboard.writeText(r.code); } catch(e){} var chip=body.querySelector('.amhg-codechip'); if(chip){chip.classList.add('ok');} var h = body.querySelector('.amhg-copyhint'); if (h) h.textContent = T.copied || 'copied'; }
    var dc = body.querySelector('[data-copy]'); if (dc) dc.addEventListener('click', copy);
    var dc2 = body.querySelector('[data-copy2]'); if (dc2) dc2.addEventListener('click', copy);
    body.querySelector('[data-apply]').addEventListener('click', function(){
      track('apply', { code: r.code });
      // ADD the won product FIRST, then apply the code. Order matters for a free-product (BXGY):
      // if the code is applied before its "get" item is in the cart, Shopify drops it and the item
      // never goes free. So we add via /cart/add.js, THEN redirect through /discount/CODE → /cart.
      var apply = function(){ location.href = '/discount/' + encodeURIComponent(r.code) + '?redirect=' + encodeURIComponent('/cart'); };
      if (hasVariant) {
        fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id: parseInt(r.product.variantId,10), quantity:1 }] }) }).then(apply).catch(apply);
      } else {
        location.href = '/discount/' + encodeURIComponent(r.code) + '?redirect=' + encodeURIComponent((r.url && r.url !== '/cart') ? r.url : (C.applyRedirect || '/'));
      }
    });
    var te = body.querySelector('[data-timer]');
    if (te && r.exp){ (function tick(){ var left = r.exp - Date.now(); if (left <= 0){ te.innerHTML = ''; return; } te.innerHTML = isProduct ? (IC.clock+' <b>'+fmtLeft(left)+'</b>') : (deEmoji(T.hurry || 'Hurry — expires in') + ' <b>' + fmtLeft(left) + '</b>'); setTimeout(tick, 1000); })(); }
  }
  /** Email gate: collect an email before revealing the code, then email it too. */
  function emailGate(r){
    body.innerHTML = '<div class="amhg-rhead">'+IC.gift+'<span>'+esc(r.label||U.youWon||'You won!')+'</span></div>'+
      '<p class="amhg-sub">'+esc(C.emailPrompt || U.emailPrompt || "Enter your email and we'll send your code — you can use it right away too.")+'</p>'+
      '<input class="amhg-input" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com">'+
      '<div class="amhg-err" style="display:none"></div>'+
      '<button class="amhg-btn" data-send style="margin-top:10px">'+esc(C.emailCta || U.emailCta || 'Email me my code')+'</button>'+
      '<p class="amhg-hint" style="margin-top:10px">'+esc(U.emailNote || 'We only use this to send your discount. No spam.')+'</p>';
    var inp = body.querySelector('.amhg-input'), er = body.querySelector('.amhg-err'), b = body.querySelector('[data-send]');
    try { inp.focus(); } catch(e){}
    function submit(){
      var v = (inp.value||'').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ er.textContent = U.emailInvalid || 'Please enter a valid email address.'; er.style.display = 'block'; return; }
      b.disabled = true; b.textContent = U.emailSending || 'Sending…';
      trackLead(v, r.code).then(function(res){ showReveal(r, (res && res.delivered) ? (U.emailSentNote || 'Sent to your inbox — and ready to use right here.') : (U.emailFallbackNote || 'Here it is — and it\'s saved on this button too.')); });
    }
    b.addEventListener('click', submit);
    inp.addEventListener('keydown', function(e){ if (e.key === 'Enter') submit(); });
  }
  // Per-winner codes: the strings in the config are FAMILIES, not redeemable codes. On a win
  // the hub mints one fresh single-use code per family for THIS winner; that is what we reveal,
  // store and apply. cb(map) — map[family] = winner code (missing = could not mint).
  function claimCodes(families, cb){
    var api = C.apiBase ? C.apiBase.replace(/\/$/,'') : null, id = C.campaignId || C.id;
    if (!api || !id || !families.length){ cb({}); return; }
    var attempt = 0;
    (function go(){
      attempt++;
      var done = false, t = setTimeout(function(){ if (!done){ done = true; attempt < 2 ? go() : cb({}); } }, 9000);
      fetch(api + '/api/public/games/' + encodeURIComponent(id) + '/claim', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ host: host, codes: families, sid: SID }) })
        .then(function(r){ return r.json(); })
        .then(function(j){ if (done) return; done = true; clearTimeout(t); cb((j && j.codes) || {}); })
        .catch(function(){ if (done) return; done = true; clearTimeout(t); attempt < 2 ? go() : cb({}); });
    })();
  }
  function claimFailed(){
    body.innerHTML = '<h3 class="amhg-title">'+esc(U.claimFailTitle || 'One moment…')+'</h3><p class="amhg-sub">'+esc(U.claimFailSub || "We couldn't prepare your code just now. Please try again.")+'</p>'+
      '<button class="amhg-btn" data-again>'+esc(U.tryAgain || 'Try again')+'</button>';
    var a = body.querySelector('[data-again]'); if (a) a.addEventListener('click', render);
  }
  function win(code, label, opts){
    opts = opts || {};
    var product = opts.product || null;
    body.innerHTML = '<h3 class="amhg-title">'+esc(U.claiming || 'Preparing your prize…')+'</h3>';
    claimCodes([code], function(map){
      var mine = map[code];
      if (!mine){ track('claimfail', { code: code }); claimFailed(); return; }
      // exp = the display/urgency countdown; lock = how long before this game can be WON again
      // (so a shopper can't farm a new free prize every day — separate from the urgency timer).
      var r = { code: mine, family: code, label: label || 'You won!', exp: expiryTs(), lock: Date.now() + (C.replayLockDays || 14)*86400000, url: (product && product.url) || C.applyRedirect || '/', product: product, minOrder: opts.minOrder || null };
      localStorage.setItem(KEY, JSON.stringify(r));
      track('win', { code: code });
      if (C.emailGate) emailGate(r); else showReveal(r);
    });
  }
  function lose(retry){
    body.innerHTML = '<h3 class="amhg-title">'+esc(U.loseTitle || 'So close!')+'</h3><p class="amhg-sub">'+esc(U.loseSub || 'Not this time.')+'</p>'+
      (retry ? '<button class="amhg-btn" data-again>'+esc(U.tryAgain || 'Try again')+'</button>' : '<button class="amhg-btn amhg-btn2" data-close>'+esc(U.close || 'Close')+'</button>');
    var a = body.querySelector('[data-again]'); if(a) a.addEventListener('click', render);
    var c = body.querySelector('[data-close]'); if(c) c.addEventListener('click', close);
  }

  function render(){
    track('play');
    playedThisSession = true;
    try { localStorage.removeItem('amh_onp'); } catch(e){}   // they played → clear the "didn't play" mark
    if (C.type === 'wheel') return renderWheel();
    if (C.type === 'swipe') return renderSwipe();
    if (C.type === 'quiz') return renderQuiz();
    if (C.type === 'scratch') return renderScratch();
    if (C.type === 'memory') return renderMemory();
    if (C.type === 'giftfinder') return renderGiftFinder();
  }

  /* ---------- SCRATCH CARD ---------- */
  function renderScratch(){
    var cfg = C.scratch || {}, prizes = cfg.prizes || [];
    if (!prizes.length) { close(); return; }
    var total = prizes.reduce(function(s,x){ return s + (x.weight||1); }, 0), r = Math.random()*total, acc = 0, prize = prizes[0];
    for (var k=0;k<prizes.length;k++){ acc += prizes[k].weight||1; if (r <= acc){ prize = prizes[k]; break; } }

    body.innerHTML = '<h3 class="amhg-title">'+esc(fill(C.title||'Scratch & win'))+'</h3><p class="amhg-sub">'+esc(fill(C.subtitle||'Scratch the card to reveal your deal'))+'</p>'+hookStrip()+
      '<div class="amhg-scratch"><div class="prize">'+
        (prize.code ? '<div style="font-size:13px;color:#888">'+esc(U.youWon||'You won')+'</div><div style="font-size:25px;font-weight:800;color:'+color+'">'+esc(prize.label||U.yourReward||'A discount')+'</div><div class="amhg-code">'+esc(prize.code)+'</div>'
                    : '<div style="font-size:22px;font-weight:700;color:#999">'+esc(prize.label||U.tryAgain||'Try again')+'</div>')+
      '</div><canvas></canvas></div><p class="amhg-hint">'+esc(U.scratchHint || 'Drag across the card to scratch it off')+'</p>';

    var wrap = body.querySelector('.amhg-scratch'), cv = body.querySelector('canvas'), ctx = cv.getContext('2d');
    var drawing = false, revealed = false;
    // Paint the foil at the card's LAID-OUT size. On the newsletter landing (?amh.play) the game
    // renders in the same tick the overlay opens, before layout — measured width was 0, so the
    // foil never painted, the prize sat exposed, and check() divided 0/0 → the win never fired
    // (found 2026-09-17). Measure again on the next frames until the card has a size.
    function paintFoil(){
      var r = wrap.getBoundingClientRect();
      if (!(r.width > 0 && r.height > 0)) return false;
      cv.width = r.width; cv.height = r.height;
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = color; ctx.fillRect(0,0,cv.width,cv.height);
      ctx.fillStyle = 'rgba(255,255,255,.9)'; ctx.font = 'bold 15px Poppins, sans-serif'; ctx.textAlign = 'center';
      ctx.fillText(U.scratchHere || 'SCRATCH HERE', cv.width/2, cv.height/2 + 5);
      ctx.globalCompositeOperation = 'destination-out';
      return true;
    }
    if (!paintFoil()){
      var tries = 0;
      (function retry(){ if (revealed || drawing || paintFoil() || ++tries > 60) return; requestAnimationFrame(retry); })();
    }
    function pt(e){ var b = cv.getBoundingClientRect(); return { x:(e.clientX-b.left)*(cv.width/b.width), y:(e.clientY-b.top)*(cv.height/b.height) }; }
    function scratch(e){ if (!drawing) return; var p = pt(e); ctx.beginPath(); ctx.arc(p.x, p.y, 22, 0, 7); ctx.fill(); check(); }
    function check(){
      if (revealed) return;
      var data = ctx.getImageData(0,0,cv.width,cv.height).data, cleared = 0, samples = 0;
      for (var i=3;i<data.length;i+=4*50){ samples++; if (data[i] === 0) cleared++; }
      if (cleared/samples > 0.48){
        revealed = true;
        cv.style.transition = 'opacity .35s'; cv.style.opacity = '0';
        setTimeout(function(){ if (prize.code) win(prize.code, prize.label || 'Your discount', { product: prize.product, minOrder: prize.minOrder }); else { localStorage.setItem(KEY, JSON.stringify({ played: true })); lose(false); } }, 380);
      }
    }
    cv.addEventListener('pointerdown', function(e){ drawing = true; try { cv.setPointerCapture(e.pointerId); } catch(_){} scratch(e); });
    cv.addEventListener('pointermove', scratch);
    cv.addEventListener('pointerup', function(){ drawing = false; });
  }

  /* ---------- MEMORY MATCH (specific products / ARTMiE images / emoji) ---------- */
  function renderMemory(){
    var cfg = C.memory || {};
    var imgs = (cfg.images || []).slice(0, 8);           // cards = ARTMiE category photos (unchanged)
    var syms = cfg.symbols || [];
    var useImg = imgs.length >= 2;
    var items = useImg ? imgs : syms;                    // each item becomes one matching pair
    var prizes = (cfg.prizes || []).filter(function(p){ return p && p.variantId; });  // free-product prize pool
    if (items.length < 2 || (!cfg.code && !prizes.length)) { close(); return; }
    var deck = [];
    for (var i=0;i<items.length;i++){ deck.push({ k:i, v:items[i] }); deck.push({ k:i, v:items[i] }); }
    for (var a=deck.length-1;a>0;a--){ var b=Math.floor(Math.random()*(a+1)), t=deck[a]; deck[a]=deck[b]; deck[b]=t; }
    var flipped = [], matched = 0, lock = false, pairs = items.length;
    body.innerHTML = '<h3 class="amhg-title">'+esc(fill(C.title||'Match to win'))+'</h3><p class="amhg-sub">'+esc(fill(C.subtitle||'Find all the matching pairs'))+'</p>'+hookStrip()+
      '<div class="amhg-grid">'+ deck.map(function(c){
        var face = useImg ? '<img class="face" src="'+esc(c.v)+'" alt="" loading="lazy">' : '<span class="face">'+esc(c.v)+'</span>';
        return '<button class="amhg-mcard'+(useImg?' amhg-mcard--img':'')+'" data-k="'+c.k+'"><span class="amhg-mback">?</span>'+face+'</button>';
      }).join('') + '</div>';
    var cols = deck.length <= 8 ? 4 : deck.length <= 12 ? 4 : 4;
    body.querySelector('.amhg-grid').style.gridTemplateColumns = 'repeat('+cols+', 1fr)';
    [].forEach.call(body.querySelectorAll('.amhg-mcard'), function(btn){
      btn.addEventListener('click', function(){
        if (lock || btn.classList.contains('flip') || btn.classList.contains('done')) return;
        btn.classList.add('flip'); flipped.push(btn);
        if (flipped.length === 2){
          lock = true;
          if (flipped[0].getAttribute('data-k') === flipped[1].getAttribute('data-k')){
            flipped.forEach(function(b){ b.classList.add('done'); }); matched++; flipped = []; lock = false;
            if (matched === pairs) setTimeout(function(){
              if (prizes.length){
                var p = prizes[Math.floor(Math.random()*prizes.length)];   // random free product
                win(p.code || cfg.code, cfg.rewardLabel || 'You won a free product!', { product: { name: p.name, img: p.img, url: p.url, variantId: p.variantId, price: p.price, currency: p.currency }, minOrder: (p.minOrder || cfg.minOrder) });
              } else {
                win(cfg.code, cfg.rewardLabel || 'Great memory!', { product: cfg.product, minOrder: cfg.minOrder });
              }
            }, 450);
          } else {
            setTimeout(function(){ flipped.forEach(function(b){ b.classList.remove('flip'); }); flipped = []; lock = false; }, 780);
          }
        }
      });
    });
  }

  /* ---------- GIFT-FINDER QUIZ (recommends products + a code) ---------- */
  function renderGiftFinder(){
    var cfg = C.giftfinder || {}, qs = cfg.questions || [], outcomes = cfg.outcomes || {};
    if (!qs.length) { close(); return; }
    var i = 0, tally = {};
    function show(){
      if (i >= qs.length) { result(); return; }
      var q = qs[i];
      body.innerHTML = '<h3 class="amhg-title">'+esc(fill(C.title||'Find your match'))+'</h3><p class="amhg-sub">'+esc((U.questionOf||'Question {i} of {n}').replace('{i}',i+1).replace('{n}',qs.length))+'</p>'+(i === 0 ? hookStrip() : '')+
        '<div class="amhg-q">'+esc(q.q)+'</div>'+ (q.options||[]).map(function(o){ return '<button class="amhg-opt" data-tag="'+esc(o.tag||'')+'">'+esc(o.label)+'</button>'; }).join('');
      [].forEach.call(body.querySelectorAll('.amhg-opt'), function(b){ b.addEventListener('click', function(){ var t = b.getAttribute('data-tag'); if (t) tally[t] = (tally[t]||0) + 1; i++; show(); }); });
    }
    function result(){
      var best = null, bestN = -1; Object.keys(tally).forEach(function(t){ if (tally[t] > bestN){ bestN = tally[t]; best = t; } });
      var oc = outcomes[best] || outcomes[Object.keys(outcomes)[0]] || {};
      var code = oc.code || cfg.fallbackCode;
      body.innerHTML = '<h3 class="amhg-title">'+esc(oc.title||'Your match!')+'</h3><p class="amhg-sub">'+esc(oc.desc||'')+'</p>'+
        '<div class="amhg-recs">'+ (oc.products||[]).slice(0,3).map(function(p){ return '<a class="amhg-rec" href="'+esc(p.url||'#')+'">'+(p.img?'<img src="'+esc(p.img)+'" alt="">':'')+'<span>'+esc(p.name||'')+'</span></a>'; }).join('') + '</div>';
      if (code){
        var btn = document.createElement('button'); btn.className = 'amhg-btn'; btn.style.marginTop = '12px'; btn.textContent = deEmoji(C.giftCta || U.giftReveal || 'Reveal my code');
        body.appendChild(btn);
        btn.addEventListener('click', function(){ win(code, oc.rewardLabel || 'Your welcome gift', { product: oc.product, minOrder: oc.minOrder }); });
      }
    }
    show();
  }

  /* ---------- WHEEL ---------- */
  function renderWheel(){
    var segs = (C.wheel && C.wheel.segments) || [];
    if (!segs.length) { close(); return; }
    body.innerHTML = '<h3 class="amhg-title">'+esc(fill(C.title||'Spin to win!'))+'</h3><p class="amhg-sub">'+esc(fill(C.subtitle||''))+'</p>'+hookStrip()+
      '<div class="amhg-wheelwrap"><div class="amhg-ptr"></div><canvas class="amhg-wheel" width="520" height="520"></canvas><div class="amhg-hub"></div></div>'+
      '<button class="amhg-btn" data-spin>'+esc(U.spin || 'SPIN')+'</button>';
    var cv = body.querySelector('canvas'), ctx = cv.getContext('2d'), n = segs.length, R = 260, arc = 2*Math.PI/n;
    var isLight = function(c){ if(!c) return false; c=(''+c).replace('#',''); if(c.length===3)c=c.split('').map(function(x){return x+x;}).join(''); var r=parseInt(c.slice(0,2),16),g=parseInt(c.slice(2,4),16),b=parseInt(c.slice(4,6),16); return (0.299*r+0.587*g+0.114*b)>180; };
    for (var i=0;i<n;i++){
      var segColor = segs[i].color || (i%2 ? '#ffffff' : color);
      var a0 = i*arc - Math.PI/2 - arc/2;
      ctx.beginPath(); ctx.moveTo(R,R); ctx.arc(R,R,R,a0,a0+arc); ctx.closePath();
      ctx.fillStyle = segColor; ctx.fill();
      ctx.save(); ctx.translate(R,R); ctx.rotate(i*arc); ctx.textAlign='center';
      ctx.fillStyle = isLight(segColor) ? '#333' : '#fff';
      ctx.font = 'bold 22px Poppins, sans-serif';
      ctx.fillText(String(segs[i].label||'').slice(0,14), 0, -R+42);
      ctx.restore();
    }
    var spun = false;
    body.querySelector('[data-spin]').addEventListener('click', function(){
      if (spun) return; spun = true; this.disabled = true;
      var total = segs.reduce(function(s,x){return s+(x.weight||1);},0), r = Math.random()*total, idx=0, acc=0;
      for (var k=0;k<n;k++){ acc+=segs[k].weight||1; if(r<=acc){ idx=k; break; } }
      var deg = 360*6 + (360 - idx*(360/n));
      cv.style.transform = 'rotate('+deg+'deg)';
      setTimeout(function(){
        var seg = segs[idx];
        if (seg.code) win(seg.code, seg.label || 'Enjoy your discount', { product: seg.product, minOrder: seg.minOrder });
        else { localStorage.setItem(KEY, JSON.stringify({ played: true })); lose(false); }
      }, 4700);
    });
  }

  /* ---------- SWIPE (Tinder-style: per-product coupons, random daily set, daily reset) ---------- */
  function todayKey(){ var d = new Date(); return d.getFullYear()+'-'+(d.getMonth()+1)+'-'+d.getDate(); }
  function renderSwipe(){
    var cfg = C.swipe || {}, pool = cfg.products || [];
    if (!pool.length) { close(); return; }
    var SKEY = 'amh_swipe_' + (C.id || 'x'), range = cfg.pick || [5, 7];
    var state; try { state = JSON.parse(localStorage.getItem(SKEY) || 'null'); } catch(e){ state = null; }
    function save(){ localStorage.setItem(SKEY, JSON.stringify(state)); }
    if (!state || state.date !== todayKey()) {                       // new day → fresh set
      var idxs = pool.map(function(_, k){ return k; });
      for (var a = idxs.length-1; a > 0; a--){ var b = Math.floor(Math.random()*(a+1)), t = idxs[a]; idxs[a] = idxs[b]; idxs[b] = t; }
      // Pick a fixed count (default 6), each with a DISTINCT 3-letter prefix.
      var want = cfg.count || (range[0] === range[1] ? range[0] : 6), chosen = [], seen = {};
      for (var qi = 0; qi < idxs.length && chosen.length < want; qi++){
        var pp = pool[idxs[qi]];
        var pref = String(pp.prefix || pp.sku || pp.name || '').slice(0, 3).toUpperCase();
        if (pref && seen[pref]) continue;               // one product per prefix
        if (pref) seen[pref] = 1;
        chosen.push(idxs[qi]);
      }
      state = { date: todayKey(), order: chosen, pos: 0, unlocked: [] };
      save();
    }
    var animating = false;

    // Skipped every card → nothing (per spec: accept = ONE coupon, skip-all = no coupon).
    function endNothing(){
      try { localStorage.setItem(KEY, JSON.stringify({ played: true })); } catch(e){}
      body.innerHTML = '<h3 class="amhg-title">'+esc(U.swipeNoneTitle || "That's all for now")+'</h3>'+
        '<p class="amhg-sub">'+esc(U.swipeNoneSub || 'Come back for a new set!')+'</p>'+
        '<button class="amhg-btn amhg-btn2" data-close>'+esc(U.close || 'Close')+'</button>';
      var cb = body.querySelector('[data-close]'); if (cb) cb.addEventListener('click', close);
    }
    // Accept ONE card → win exactly that deal and STOP. You get one coupon, never several.
    function swipeAccept(p){
      var pct = parseInt(String(p.deal||'').replace(/[^0-9]/g,''), 10) || 0;
      var voucher = { code: p.code, free: false, pct: pct, name: p.name, variantTitle: p.variantTitle || p.size, img: p.img, url: p.url, variantId: p.variantId, minOrder: p.minOrder };
      showMultiReveal([voucher], null, false, (U.swipeDealsTitle || U.savedDeal || 'Your deal'), true);
    }
    var SVG_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var SVG_HEART = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.6-4.7-9.9-9.2C.7 8.5 2.3 4.9 5.9 4.9c2 0 3.4 1.2 4.1 2.4C10.7 6.1 12.1 4.9 14.1 4.9c3.6 0 5.2 3.6 3.8 6.9C15.6 16.3 12 21 12 21z"/></svg>';
    function cardEl(p, bg){
      var el = document.createElement('div'); el.className = 'amhg-swipe' + (bg ? ' bg' : '');
      el.innerHTML = (p.img ? '<img src="'+esc(p.img)+'" alt="">' : '<div style="width:100%;height:100%;background:#eee"></div>')+
        '<div class="info"><div class="nm">'+esc(p.name||'')+(p.variantTitle?' <span style="font-weight:500;opacity:.9">· '+esc(p.variantTitle)+'</span>':'')+'</div>'+(p.deal ? '<div class="deal"><span>'+esc(p.deal)+'</span></div>' : '')+'</div>'+
        (bg ? '' : '<div class="amhg-tag like">'+esc(U.swipeLikeTag || 'SAVE')+'</div><div class="amhg-tag nope">'+esc(U.swipeNopeTag || 'SKIP')+'</div>');
      return el;
    }
    function fly(el, dir, p){
      if (animating) return; animating = true;
      el.style.transition = 'transform .35s ease-out, opacity .35s';
      el.style.transform = 'translateX('+(dir*640)+'px) rotate('+(dir*28)+'deg)'; el.style.opacity = '0';
      setTimeout(function(){
        animating = false;
        if (dir > 0 && p.code){ state.pos = state.order.length; save(); swipeAccept(p); }  // accept → win ONE + stop
        else { state.pos++; save(); draw(); }                                                // skip → next card
      }, 340);
    }
    function enableDrag(el, p){
      var sx = 0, dx = 0, drag = false;
      var like = el.querySelector('.amhg-tag.like'), nope = el.querySelector('.amhg-tag.nope');
      el.addEventListener('pointerdown', function(e){ drag = true; sx = e.clientX; el.style.transition = 'none'; try { el.setPointerCapture(e.pointerId); } catch(_){} });
      el.addEventListener('pointermove', function(e){ if (!drag) return; dx = e.clientX - sx; el.style.transform = 'translateX('+dx+'px) rotate('+(dx/18)+'deg)'; like.style.opacity = Math.max(0, dx/80); nope.style.opacity = Math.max(0, -dx/80); });
      el.addEventListener('pointerup', function(){ if (!drag) return; drag = false; el.style.transition = 'transform .3s'; if (dx > 90) fly(el, 1, p); else if (dx < -90) fly(el, -1, p); else { el.style.transform = ''; like.style.opacity = 0; nope.style.opacity = 0; } dx = 0; });
    }
    function draw(){
      if (state.pos >= state.order.length) { endNothing(); return; }
      var cur = pool[state.order[state.pos]];
      var next = (state.pos+1 < state.order.length) ? pool[state.order[state.pos+1]] : null;
      body.innerHTML = '<h3 class="amhg-title">'+esc(fill(C.title||'Swipe to unlock'))+'</h3><p class="amhg-sub">'+esc(fill(C.subtitle||'Swipe right to save the deal, left to skip'))+'</p>'+hookStrip()+
        '<div class="amhg-cards"></div>'+
        '<p class="amhg-swhint">'+esc(U.swipeHint || 'Drag the card left or right — or tap the buttons')+'</p>'+
        '<div class="amhg-swrow">'+
          '<button class="amhg-swbtn" data-act="nope"><span class="amhg-round nope">'+SVG_X+'</span>'+esc(U.swipeSkip || 'Skip')+'</button>'+
          '<button class="amhg-swbtn" data-act="yes"><span class="amhg-round yes">'+SVG_HEART+'</span>'+esc(U.swipeSave || 'Save')+'</button>'+
        '</div>';
      var stack = body.querySelector('.amhg-cards');
      // Blurred next card sits behind the top one — Tinder-style depth, and no white gap on swipe.
      if (next) stack.appendChild(cardEl(next, true));
      var top = cardEl(cur, false); stack.appendChild(top);
      enableDrag(top, cur);
      body.querySelector('[data-act="yes"]').addEventListener('click', function(){ fly(top, 1, cur); });
      body.querySelector('[data-act="nope"]').addEventListener('click', function(){ fly(top, -1, cur); });
    }
    // Preload every picked image so the next card appears instantly (kills the ~1s white gap).
    try { (state.order || []).forEach(function(i){ if (pool[i] && pool[i].img){ var im = new Image(); im.src = pool[i].img; } }); } catch(e){}
    draw();
  }

  /* ---------- PRODUCT QUIZ (photo Qs → tiered voucher bundle 9/6/3) ---------- */
  function stripAbc(s){ return String(s==null?'':s).replace(/^\s*[A-Ca-c]\)\s*/, ''); }
  function renderQuiz(){
    var cfg = C.quiz || {}, bank = cfg.questions || [], vouchers = cfg.vouchers || [];
    var perPlay = cfg.perPlay || 6, tiers = cfg.tiers || { perfect: 9, oneWrong: 6, more: 3 };
    if (!bank.length || !vouchers.length) { close(); return; }

    // Pick `perPlay` questions we haven't shown recently → a retry gets a DIFFERENT set.
    var SEENK = 'amh_quizseen_' + (C.campaignId || C.id || 'x'), seen = [];
    try { seen = JSON.parse(localStorage.getItem(SEENK) || '[]') || []; } catch(e){ seen = []; }
    var fresh = bank.filter(function(q){ return seen.indexOf(q.id) === -1; });
    if (fresh.length < perPlay) { seen = []; fresh = bank.slice(); }   // exhausted → fresh round
    for (var a=fresh.length-1;a>0;a--){ var b=Math.floor(Math.random()*(a+1)), t=fresh[a]; fresh[a]=fresh[b]; fresh[b]=t; }
    var picks = fresh.slice(0, Math.min(perPlay, fresh.length));
    try { picks.forEach(function(q){ if (seen.indexOf(q.id) === -1) seen.push(q.id); }); localStorage.setItem(SEENK, JSON.stringify(seen)); } catch(e){}

    var i = 0, correct = 0, answered = false;
    function show(){
      if (i >= picks.length) { finish(); return; }
      var q = picks[i], last = (i + 1 >= picks.length);
      body.innerHTML = '<h3 class="amhg-title">'+esc(fill(C.title||'Quiz'))+'</h3>'+
        (i === 0 && C.subtitle ? '<p class="amhg-sub" style="margin-bottom:8px">'+esc(fill(C.subtitle))+'</p>' : '')+
        '<p class="amhg-sub">'+esc((U.questionOf||'Question {i} of {n}').replace('{i}',i+1).replace('{n}',picks.length))+'</p>'+
        (i === 0 ? hookStrip() : '')+
        (q.img ? '<img class="amhg-qimg" src="'+esc(q.img)+'" alt="" loading="lazy">' : '')+
        '<div class="amhg-q">'+esc(q.q)+'</div>'+
        (q.options||[]).map(function(o,j){ return '<button class="amhg-opt" data-j="'+j+'">'+esc(stripAbc(o))+'</button>'; }).join('')+
        '<div class="amhg-qfb" style="display:none"></div>';
      answered = false;
      [].forEach.call(body.querySelectorAll('.amhg-opt'), function(btn){
        btn.addEventListener('click', function(){
          if (answered) return; answered = true;
          var j = parseInt(btn.dataset.j, 10), right = (j === q.correct);
          if (right) correct++;
          [].forEach.call(body.querySelectorAll('.amhg-opt'), function(bb, k){ bb.disabled = true; if (k === q.correct) bb.classList.add('ok'); else if (k === j) bb.classList.add('bad'); });
          var fb = body.querySelector('.amhg-qfb');
          fb.className = 'amhg-qfb ' + (right ? 'ok' : 'bad');
          fb.innerHTML = '<b>'+esc(right ? (U.quizRight||'Correct!') : (U.quizWrong||'Not quite'))+'</b>'+
            (q.fact ? '<span>'+esc(q.fact)+'</span>' : '')+
            '<button class="amhg-btn amhg-qnext" data-next>'+esc(last ? (U.quizSeeReward||'See my vouchers') : (U.quizNext||'Next'))+'</button>';
          fb.style.display = '';
          fb.querySelector('[data-next]').addEventListener('click', function(){ i++; show(); });
        });
      });
    }
    function finish(){
      var wrong = picks.length - correct;
      var n = wrong === 0 ? tiers.perfect : (wrong === 1 ? tiers.oneWrong : tiers.more);
      var won = vouchers.slice(0, Math.min(n, vouchers.length));   // ordered best-first
      var tpl = wrong === 0 ? (U.quizPerfect || 'Perfect! You unlocked all {max} vouchers.')
              : wrong === 1 ? (U.quizOneWrong || 'You missed one question, so you get {got} vouchers instead of {max}.')
              : (U.quizSome || 'Nice one! You unlocked {got} vouchers.');
      var msg = tpl.replace('{got}', won.length).replace('{max}', tiers.perfect).replace('{score}', correct).replace('{n}', picks.length);
      showMultiReveal(won, msg);
    }
    show();
  }

  /** Reveal a BUNDLE of vouchers (quiz reward): each card = photo, name, FREE/−X%, tap-copy code, add-to-basket. */
  function showMultiReveal(vouchers, note, replay, title, noRetry){
    if (!replay){
      // Mint this winner's codes first; a voucher we cannot mint is dropped rather than shown
      // with a family string that nothing will redeem.
      body.innerHTML = '<h3 class="amhg-title">'+esc(U.claiming || 'Preparing your vouchers…')+'</h3>';
      claimCodes(vouchers.map(function(v){ return v.code; }), function(map){
        var minted = [];
        vouchers.forEach(function(v){ if (map[v.code]) minted.push(Object.assign({}, v, { family: v.code, code: map[v.code] })); });
        if (!minted.length){ track('claimfail', { code: vouchers[0] && vouchers[0].code, count: vouchers.length }); claimFailed(); return; }
        track('win', { code: (vouchers[0] && vouchers[0].code) || null, count: minted.length });
        var rec = { multi: true, played: true, vouchers: minted, note: note, exp: expiryTs(), lock: Date.now() + (C.replayLockDays || 14)*86400000 };
        try { localStorage.setItem(KEY, JSON.stringify(rec)); } catch(e){}
        showMultiReveal(minted, note, true, title, noRetry);
      });
      return;
    }
    var pctTpl = U.quizPctOff || '{pct}% off';
    body.innerHTML = '<div class="amhg-rhead">'+IC.gift+'<span>'+esc(title || U.quizRewardTitle || 'Your vouchers')+'</span></div>'+
      (note ? '<p class="amhg-sub" style="margin:-8px 0 14px">'+esc(note)+'</p>' : '')+
      '<div class="amhg-vouchers">'+ vouchers.map(function(v){
        var isFree = !!v.free;
        var badge = isFree ? '<span class="amhg-vbadge free">'+esc(U.free || 'FREE')+'</span>' : '<span class="amhg-vbadge">'+esc(pctTpl.replace('{pct}', v.pct))+'</span>';
        var minl = (isFree && v.minOrder) ? '<div class="amhg-vmin">'+esc((U.freeCondition || 'Free when you add {x} of other products to your basket').replace('{x}', v.minOrder))+'</div>' : '';
        return '<div class="amhg-vcard'+(isFree?' free':'')+'">'+
            (v.img ? '<img src="'+esc(v.img)+'" alt="">' : '')+
            '<div class="amhg-vinfo"><div class="amhg-vname">'+esc(v.name||'')+(v.variantTitle?' <span style="font-weight:500;color:#888">· '+esc(v.variantTitle)+'</span>':'')+'</div>'+
              badge+minl+
              '<div class="amhg-vcode" data-copy="'+esc(v.code)+'" title="'+esc(U.tapToCopy||'tap to copy')+'">'+esc(v.code)+'</div>'+
            '</div>'+
            '<button class="amhg-vadd" data-vid="'+esc(v.variantId||'')+'" data-shop="'+esc(v.url||'/')+'" data-code="'+esc(v.code)+'">'+IC.bag+'<span>'+esc(U.addToBasket || 'Add to basket')+'</span></button>'+
          '</div>';
      }).join('') + '</div>'+
      '<p class="amhg-hint" style="margin:12px 0 4px">'+esc(U.quizPickHint || 'Tap a voucher to add it to your basket — the discount is already applied.')+'</p>'+
      (noRetry ? '' : '<button class="amhg-btn amhg-btn2" data-retry style="margin-top:6px">'+esc(U.quizRetry || 'Play again — new questions')+'</button>');
    // Add exactly that variant to the cart FIRST, then apply the code (order matters for a
    // free-product BXGY — see showReveal). Add via /cart/add.js, then redirect through /discount.
    [].forEach.call(body.querySelectorAll('.amhg-vadd'), function(b){ b.addEventListener('click', function(){
      var vid = b.getAttribute('data-vid'), code = b.getAttribute('data-code');
      track('apply', { code: code });
      var apply = function(){ location.href = '/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent('/cart'); };
      if (vid) { fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id: parseInt(vid,10), quantity:1 }] }) }).then(apply).catch(apply); }
      else { location.href = '/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(b.getAttribute('data-shop')||'/'); }
    }); });
    [].forEach.call(body.querySelectorAll('[data-copy]'), function(el){ el.addEventListener('click', function(){ try { navigator.clipboard.writeText(el.getAttribute('data-copy')); el.textContent = (U.copied || 'copied'); } catch(e){} }); });
    // Retry is allowed (replay lock only guards a re-WIN of the SAME saved bundle on reopen).
    var rb = body.querySelector('[data-retry]'); if (rb) rb.addEventListener('click', function(){ try { localStorage.removeItem(KEY); } catch(e){} render(); });
  }
  } // end bootMain()
  // Run boot() only once the page is loaded AND the browser is idle (with a 3s safety cap so it
  // still runs on very busy pages). requestIdleCallback keeps it off the load critical path.
  var whenIdle = window.requestIdleCallback || function(f){ return setTimeout(function(){ f(); }, 1); };
  function go(){ whenIdle(boot, { timeout: 3000 }); }
  if (document.readyState === 'complete') go();
  else window.addEventListener('load', go, { once: true });
})();
